/*
 * Дословная копия прежнего списка тем. Оставлена для личных и админских
 * страниц; публичный /themes переведён на постраничный Themes.js.
 *
 * Замечания линтера здесь давние и относятся к коду, который я не писал:
 * править их заодно с переездом — значит смешать в одном коммите две
 * несвязанные вещи.
 */
/* eslint-disable react/prop-types, react/sort-comp, class-methods-use-this, react/no-access-state-in-setstate, css-modules/no-unused-class, css-modules/no-undef-class, no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import withStyles from 'isomorphic-style-loader/withStyles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import ThemeThumb from '../../components/Common/ThemeThumb/ThemeThumb';
import s from './ThemesScroll.css';

/**
 * Список тем с бесконечным скроллом — прежний компонент.
 *
 * Оставлен для личных и админских списков (/themes/my, /themes/by/:id,
 * /themes/all): там нет робота, которому нужны ссылки, зато есть привычный
 * сценарий «листать своё».
 *
 * Публичный /themes переведён на постраничный Themes.js: робот не скроллит
 * и видел первые двадцать тем из четырёхсот.
 */
class ThemesScroll extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			page: 1,
			lastPage: false, // На последней странице не было элементов. Дальше страницы не грузим
			themes: Array.isArray(this.props.themes) ? this.props.themes : [],
		};
	}

	isBottom(el) {
		return el.getBoundingClientRect().bottom <= window.innerHeight + 100;
	}

	componentDidMount() {
		document.addEventListener('scroll', this.trackScrolling.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.trackScrolling.bind(this));
	}

	setLastPage() {
		this.setState({ lastPage: true, loading: false });
	}

	getLoadQuery() {
		if (typeof this.props.getLoadQuery === 'function') {
			return this.props.getLoadQuery(this.state.page);
		}

		return `{themes(page:${this.state.page}){id,title,installs,description,workspace}}`;
	}

	async loadNextPage() {
		this.setState({ loading: true, page: this.state.page + 1 });

		const resp = await this.props.fetch('/graphql', {
			body: JSON.stringify({
				query: this.getLoadQuery(),
			}),
		});

		let themes = await resp.json();

		if (themes.data && themes.data.themes) {
			themes = themes.data.themes;

			if (themes.length > 0) {
				this.setState({
					loading: false,
					themes: this.state.themes.concat(themes),
				});
			}

			if (themes.length < 10) {
				this.setLastPage();
			}
		} else {
			this.setLastPage();
		}
	}

	trackScrolling() {
		if (!this.state.loading && !this.state.lastPage) {
			const wrappedElement = document.getElementById('theme-container');

			if (wrappedElement && this.isBottom(wrappedElement)) {
				this.loadNextPage();
			}
		}
	}

	render() {
		return (
			<div id="theme-container" className={s.root}>
				<Container maxWidth="md">
					<Grid container>
						{this.state.themes.map(item => (
							<Grid item md={4}>
								<ThemeThumb theme={item} />
							</Grid>
						))}
					</Grid>

					{this.state.loading && <LinearProgress />}
				</Container>
			</div>
		);
	}
}

export default withStyles(s)(ThemesScroll);
